import React from "react";

export function Badge({ value, children }) {
  const label = children ?? value;
  if (label == null || label === "") return <span className="dmp-muted">—</span>;
  const variant = String(value ?? "").replace(/\s+/g, "-");
  return <span className={`dmp-badge dmp-badge--${variant}`}>{label}</span>;
}

export function Stat({ label, value, icon: Icon, tone }) {
  return (
    <div className={`dmp-stat${tone ? ` dmp-stat--${tone}` : ""}`}>
      {Icon ? (
        <span className="dmp-stat__icon" aria-hidden="true">
          <Icon />
        </span>
      ) : null}
      <div className="dmp-stat__body">
        <div className="dmp-stat__label">{label}</div>
        <div className="dmp-stat__value">{value}</div>
      </div>
    </div>
  );
}

export function Field({ label, full = false, children }) {
  return (
    <label className={`dmp-field${full ? " dmp-field--full" : ""}`}>
      {label}
      {children}
    </label>
  );
}

export function Options({ values, blank, format }) {
  return (
    <>
      {blank !== undefined ? <option value="">{blank}</option> : null}
      {(values || []).map((v) => (
        <option key={v} value={v}>
          {format ? format(v) : v}
        </option>
      ))}
    </>
  );
}

export function UserOptions({ users, blank = "Unassigned" }) {
  return (
    <>
      <option value="">{blank}</option>
      {(users || []).map((u) => (
        <option key={u.User_Id} value={u.User_Id}>
          {u.Name || `User #${u.User_Id}`}
        </option>
      ))}
    </>
  );
}

export function ErrorBox({ message }) {
  return message ? <div className="dmp-error">{message}</div> : null;
}
